import { Switch, Tooltip, styled, IconButton } from "@mui/material";
import LightModeIcon from "@mui/icons-material/LightMode";
import DarkModeIcon from "@mui/icons-material/DarkMode";
import { useThemeMode } from "../../Contexts/ThemeModeContext";

// ícone do sol (raios) na cor âmbar
const iconeSol = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
  "#F9A825"
)}" d="M9.3 1.7h1.4v2.5H9.3zM4 3l1.8 1.8-1 1L3 4zm12 0l1 1-1.8 1.8-1-1zM10 5.6A4.4 4.4 0 1010 14.4 4.4 4.4 0 0010 5.6zM1.7 9.3h2.5v1.4H1.7zm14.1 0h2.5v1.4h-2.5zM4.8 15.2l-1 1L2 14.4l1-1zm11.2-.8l1.8 1.8-1 1-1.8-1.8zM9.3 15.8h1.4v2.5H9.3z"/></svg>')`;

// ícone da lua (crescente) na cor amarelo pálido
const iconeLua = `url('data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" height="20" width="20" viewBox="0 0 20 20"><path fill="${encodeURIComponent(
  "#FDE68A"
)}" d="M14.5 12.9A6.7 6.7 0 016.9 3.5a6.7 6.7 0 108.6 9.4 6.9 6.9 0 01-1 0z"/></svg>')`;

/**
 * Switch de tema: sol amarelo (claro) / lua pálida (escuro),
 * com fundo quente de dia e noturno de noite.
 */
const TemaSwitch = styled(Switch)(() => ({
  width: 80,
  height: 44,
  padding: 9,
  "& .MuiSwitch-switchBase": {
    margin: 1,
    padding: 0,
    transform: "translateX(8px)",
    "&.Mui-checked": {
      transform: "translateX(28px)",
      "& .MuiSwitch-thumb": {
        backgroundColor: "#3a3f4b",
        "&::before": { backgroundImage: iconeLua },
      },
      "& + .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "#5b6480",
        border: "1px solid rgba(255,255,255,0.25)",
      },
    },
  },
  "& .MuiSwitch-thumb": {
    backgroundColor: "#FFF6DA",
    width: 40,
    height: 40,
    boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
    "&::before": {
      content: "''",
      position: "absolute",
      width: "100%",
      height: "100%",
      left: 0,
      top: 0,
      backgroundRepeat: "no-repeat",
      backgroundPosition: "center",
      backgroundSize: "24px 24px",
      backgroundImage: iconeSol,
    },
  },
  "& .MuiSwitch-track": {
    opacity: 1,
    backgroundColor: "#FFCF7A",
    borderRadius: 26 / 2,
  },
}));

interface ThemeToggleProps {
  /** "switch" = switch estilizado (padrão) | "icon" = botão de ícone compacto */
  variant?: "switch" | "icon";
}

export function ThemeToggle({ variant = "switch" }: ThemeToggleProps) {
  const { modo, toggleTema } = useThemeMode();
  const escuro = modo === "dark";
  const titulo = escuro ? "Mudar para tema claro" : "Mudar para tema escuro";

  if (variant === "icon") {
    return (
      <Tooltip title={titulo}>
        <IconButton onClick={toggleTema} sx={{ color: "text.secondary" }}>
          {escuro ? <LightModeIcon /> : <DarkModeIcon />}
        </IconButton>
      </Tooltip>
    );
  }

  return (
    <Tooltip title={titulo}>
      <TemaSwitch checked={escuro} onChange={toggleTema} />
    </Tooltip>
  );
}
